import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

import { IBasicCheckBoxProps } from './BasicCheckBox.types';

export default function BasicCheckBox({
  label = '',
  ...props
}: IBasicCheckBoxProps) {
  return (
    <FormControlLabel
      sx={{ mb: 0, mr: 0, width: 'fit-content' }}
      control={<Checkbox size="small" {...props} />}
      label={label}
    />
  );
}
